import { type MCPServerInfo } from '../../types';

const GoogleGmailOfficialServer: MCPServerInfo = {
  serverId: 'GOOGLE_GMAIL_OFFICIAL',
  name: 'Gmail (Official)',
  slug: 'gmail',
  description:
    'Official Google-hosted Gmail MCP Server for managing drafts, labels, threads, and searching email',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://gmailmcp.googleapis.com/mcp/v1',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GoogleGmailOfficialServer;
